import React from 'react';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Text, Flex, Box, NakedButton, LoadingIndicator } from 'roo-ui/components';

const MAP_UI_SHADOW = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';

const Wrapper = styled(Flex)`
  margin-bottom: ${themeGet('space.5')};

  flex-direction: column;
  justify-content: center;
  min-height: 40px;
  background: white;
  border-radius: ${themeGet('radii.rounded')};
  box-shadow: ${MAP_UI_SHADOW};
  opacity: 0;
  transform: translate3d(0, -40px, 0);
  transition: transform 250ms ease, opacity 250ms ease;

  &[data-show] {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

const RedoSearchButton = styled(NakedButton)`
  height: 100%;
  min-height: 40px;
  border-radius: ${themeGet('radii.rounded')};
  padding: 0 ${themeGet('space.6')};
  background: ${themeGet('colors.red')};
`;

const MapStateIndicator = React.memo(({ isMapBoundsDirty, isLoading, onClick }) => (
  <Wrapper data-testid="wrapper" data-show={isLoading || isMapBoundsDirty ? '' : undefined}>
    {isLoading && (
      <Box px={6}>
        <LoadingIndicator size={12} height="100%" />
      </Box>
    )}

    {!isLoading && isMapBoundsDirty && (
      <RedoSearchButton onClick={onClick}>
        <Text color="white" fontSize={['base']} fontWeight={['bold']}>
          Redo search in this area
        </Text>
      </RedoSearchButton>
    )}
  </Wrapper>
));

MapStateIndicator.propTypes = {
  isMapBoundsDirty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

MapStateIndicator.displayName = 'MapStateIndicator';

export default MapStateIndicator;
